import React from "react";

const BookingWidgetSkeleton = () => {
  return (
    <div className="listingSectionSidebar__wrap shadow-xl space-y-4 animate-pulse">
      {/* Price section */}
      <div className="flex justify-between items-center">
        <div className="w-24 h-8 bg-gray-300 rounded-md"></div>
        <div className="w-16 h-5 bg-gray-300 rounded-md"></div>
      </div>

      {/* Form Skeleton */}
      <div className="border border-neutral-200 dark:border-neutral-700 rounded-3xl p-4 space-y-4">
        <div className="flex-1 h-12 bg-gray-200 rounded-md"></div>
        <div className="w-full h-px bg-neutral-200 dark:bg-neutral-700"></div>
        <div className="flex-1 h-12 bg-gray-200 rounded-md"></div>
      </div>

      {/* Error message */}
      <div className="w-80 h-4 bg-gray-300 rounded-md"></div>

      {/* Quote section skeleton */}
      <div className="space-y-2">
        <div className="flex justify-between">
          <div className="w-32 h-5 bg-gray-300 rounded-md"></div>
          <div className="w-16 h-5 bg-gray-300 rounded-md"></div>
        </div>
        <div className="flex justify-between">
          <div className="w-24 h-5 bg-gray-300 rounded-md"></div>
          <div className="w-16 h-5 bg-gray-300 rounded-md"></div>
        </div>
        <div className="w-full h-px bg-neutral-200 dark:bg-neutral-700 my-2"></div>
        <div className="flex justify-between">
          <div className="w-28 h-5 bg-gray-300 rounded-md"></div>
          <div className="w-16 h-5 bg-gray-300 rounded-md"></div>
        </div>
      </div>

      {/* Button Skeleton */}
      <div className="h-12 bg-gray-300 rounded-md"></div>
    </div>
  );
};

export default BookingWidgetSkeleton;